"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemType = void 0;
var ItemType;
(function (ItemType) {
    ItemType[ItemType["None"] = 0] = "None";
    ItemType[ItemType["Ring"] = 1] = "Ring";
    ItemType[ItemType["Necklace"] = 2] = "Necklace";
    ItemType[ItemType["Armor"] = 3] = "Armor";
    ItemType[ItemType["OneHandedWeapon"] = 4] = "OneHandedWeapon";
    ItemType[ItemType["TwoHandedWeapon"] = 5] = "TwoHandedWeapon";
    ItemType[ItemType["Shield"] = 6] = "Shield";
    ItemType[ItemType["OffHandItem"] = 7] = "OffHandItem";
    ItemType[ItemType["CharacterSkin"] = 8] = "CharacterSkin";
    ItemType[ItemType["Helmet"] = 9] = "Helmet";
    ItemType[ItemType["Hat"] = 10] = "Hat";
    ItemType[ItemType["Charm"] = 11] = "Charm";
    ItemType[ItemType["Consumable"] = 10000] = "Consumable";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
